export default __webpack_public_path__ + "fdd02885e406dac9de55c9d15124ffc7.jpg";